/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

$( document ).ready(function() {


  
if(localStorage.getItem("FlexSpendUsed") == "NaN" || localStorage.getItem("FlexSpendUsed") == "undefined")  {

var arr=[];

if ($('[data-bdf]').find('span').length == 0) {
 
  var used = Number(0).toFixed(2);
}

else {

  $('[data-bdf]').find('span').each(function(){
    var item = $(this).attr('data-price'),
        qty = $(this).attr('data-qty');
        item = Number(item) * Number(qty);
        arr.push(item); 
    });
    
    var used =  arr.reduce((a, b) => a + b, 0);

}

localStorage.setItem("FlexSpendUsed", used);
  
}

if (sessionStorage.getItem("sessionUsesBFD") == null ||  sessionStorage.getItem("sessionUsesBFD") == "true" ) {

  var arr_2=[];

  if ($('[data-bdf]').find('span').length == 0) {
   
    localStorage.setItem("FlexSpendUsed", Number(0).toFixed(2));
  }

  else {

    $('[data-bdf]').find('span').each(function(){
      var item = $(this).attr('data-price'),
          qty = $(this).attr('data-qty');
          item = Number(item) * Number(qty);
          arr_2.push(item); 
      });
      
      var used =  arr_2.reduce((a, b) => a + b, 0);

      localStorage.setItem("FlexSpendUsed", used);


  }
     
 } 

});

(function() {
  // Add custom code below this line


    //**********************************
    // START Flex Spend Functionality Scripts 
    //**********************************


    // Variables global

    var flexPage = document.getElementById("flexspend__wrapper"),
         cart = document.getElementById('cart-dropdown'),
         isCartPage = document.querySelector('.cart__form');

    if (flexPage) {


    // Variables "/pages/flex-spend"

      var flexSpendBtns = document.querySelectorAll('[id^="flexspend__addbtn-"]'),
          flexSpendRemainSelector = document.querySelector('.flexspend__remaining p span'),
          flexSpendUsedSelector = document.querySelector('.flexspend__used p span'),
          flexSpendRemain = flexSpendRemainSelector.getAttribute('data-remaining'),
          flexSpendUsed = flexSpendUsedSelector.getAttribute('data-used'),
          flexSpendInfo = document.querySelector(".customer-info");
         
          if(window.outerWidth < 768) {
           var height =  document.querySelector(".flexspend__description").offsetHeight,
               headerHeight = document.querySelector(".theme__header").offsetHeight,
               infoTop = headerHeight - height;
               document.querySelector(".flexspend__info").style.top = infoTop + "px";
            
          }

          else {
            var headerHeight = document.querySelector(".theme__header").offsetHeight;            
               document.querySelector(".flexspend__info").style.top = headerHeight + "px";
          }
    }

    // if (localStorage.getItem('FlexSpendUsed') == 'NaN') {
    //   localStorage.setItem("FlexSpendUsed", Number(0).toFixed(2));
    //   CartJS.clear();
    //   let _cartDrawer = window.cart;           
    //         setTimeout(function(){
    //           _cartDrawer.getCart();
    //           //_cartDrawer.openCartDropdown();
    //         },750); 
    // }
 
    if (sessionStorage.getItem("sessionUsesBFD") == null) {

      if (!isCartPage) {
       
       cart.querySelectorAll('.flexSpendCartItem').forEach(function(el){
        
        var id = el.querySelector('a.cart-item__remove').getAttribute('data-product-id'),
            original_price = el.getAttribute('data-original-price'),
            qty = el.querySelector('span[data-qty]').getAttribute('data-qty');
            qty = parseFloat(qty);
            total_price = original_price * qty;
             if ( sessionStorage.getItem('flexproduct-' + id) == null ) {
              sessionStorage.setItem('flexproduct-' + id, total_price);
             } 
             
      });
     
      
      } else {
        // console.log('cart-page')
      }
         
     }

    // Set sessionStorage for remain/used fields. Override default remain/used fields when page updated

    if (localStorage.getItem("FlexSpendUsed") == null) {
      localStorage.setItem("FlexSpendUsed", Number(0).toFixed(2));


    } else {
      flexSpendUsed = localStorage.getItem("FlexSpendUsed");
      flexSpendUsed = parseFloat(flexSpendUsed).toFixed(2);

      if (flexPage) {

        // set storage for max use flex spend amount 

        
        localStorage.setItem("flexMaxUse", flexSpendRemain);

        localStorage.setItem("discountAmount", flexSpendRemain * 100);

        var  maxUse = localStorage.getItem("flexMaxUse");
        
        flexSpendRemain = Number(flexSpendRemain).toFixed(2);
        flexSpendRemain = flexSpendRemain - flexSpendUsed;

        //set remaining amount

        if (flexSpendRemain < 0) {
          flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
          flexSpendRemainSelector.textContent = Number(0).toFixed(2);
          
        // calculate chargeAmount and show html block
        
        let html = flexSpendInfo.querySelector('span'),
            flexCharge = localStorage.getItem("flexCharge");

            if (flexCharge) {
              //flexCharge = flexSpendUsed - maxUse;
              flexCharge = parseFloat(flexCharge);
              flexCharge = Math.abs(flexCharge);     
              html.innerHTML = "$" + flexCharge.toFixed(2);
              flexSpendInfo.classList.add('visible');
            }  else {
              let flexCharge = flexSpendUsed - maxUse;
              flexCharge = parseFloat(flexCharge);
              flexCharge = Math.abs(flexCharge);     
              html.innerHTML = "$" + flexCharge.toFixed(2);
              flexSpendInfo.classList.add('visible');
              localStorage.setItem("flexCharge", flexCharge);
   
            }

        } else {

            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(flexSpendRemain).toFixed(2);
            localStorage.removeItem("flexCharge");
        }

        //set used amount 
        // flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
        // flexSpendUsedSelector.textContent = Number(flexSpendUsed).toFixed(2);
     
        if (Number(flexSpendUsed) > Number(maxUse)) {

          flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
          flexSpendUsedSelector.textContent = Number(maxUse).toFixed(2);

        } else {

          flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
          flexSpendUsedSelector.textContent = Number(flexSpendUsed).toFixed(2);
        }

      }
  
    }

    // Relate the functions with theme events


    // document.addEventListener('cart:add', function () {

    //   setTimeout(function () {
    //     var cart = document.getElementById('cart-dropdown'),
    //       cartLineRemove = cart.querySelectorAll('.cart-item__remove');

    //     cartLineRemove.forEach(function (item) {

    //       indicateFlexProduct(item);
    //       removeItemFlexFromCart(item);

    //     });
    //   }, 3500);

    // });

    document.addEventListener('update-cart',  function(){
      updateCartDrawer();
      updateCart();
     
    } );

    document.dispatchEvent(
      new CustomEvent('update-cart')
    );

 if (document.querySelector('[data-add-to-cart]') != null)  {
  document.querySelector('[data-add-to-cart]').addEventListener('click', function (e) {

    setTimeout( updateCartDrawer, 1500);
    //updateCartDrawer();

  });
 }


    // Flex product button scripts

    if (flexPage) {

      flexSpendBtns.forEach(function (flexSpendAdd) {

        let productID = flexSpendAdd.getAttribute("data-product-id");
           

        // Check if current flex spend product already in sessionStorage
        if (sessionStorage.getItem('flexproduct-' + productID) != null) {
          let flexSpendBtnText = flexSpendAdd.querySelector('span');

          flexSpendAdd.classList.add('added');
          flexSpendBtnText.textContent = "Remove From BDF";
          //flexSpendAdd.removeAttribute('data-add-to-cart');
        }

        flexSpendAdd.addEventListener('click', function (e) {

          if (flexSpendAdd.hasAttribute('disabled')) {
            return;
          }

              var flexSpendItemPrice = Number(flexSpendAdd.getAttribute('data-price')),
              itemPriceNonDecimal = Number(flexSpendAdd.getAttribute('data-price-non-decimal')),

              flexSpendBtnText = flexSpendAdd.querySelector('span'),
              flexSpendUsed = localStorage.getItem("FlexSpendUsed"),
              productID = flexSpendAdd.getAttribute("data-product-id"),
              flexSpendRemain = flexSpendRemainSelector.getAttribute('data-remaining'),
              variantID = flexSpendAdd.getAttribute("data-variant-id");

               
              flexSpendUsed = parseFloat(flexSpendUsed);
              flexSpendRemain = Number(flexSpendRemain);

          if (flexSpendAdd.classList.contains('disabled')) {

            return;

          } 
          
          else if (flexSpendAdd.classList.contains('added')) {

            // remove flex item from cart

            removeFlexSpend(flexSpendAdd, productID, variantID, flexSpendItemPrice, flexSpendBtnText, flexSpendUsed, flexSpendRemain);

          } else if (!flexSpendAdd.classList.contains('added')) {

            // add flex item to cart


            addFlexSpend(flexSpendAdd, productID, variantID, flexSpendItemPrice, itemPriceNonDecimal, flexSpendBtnText, flexSpendUsed, flexSpendRemain);

          }
        });

        function removeFlexSpend(flexSpendAdd, productID, variantID, flexSpendItemPrice, flexSpendBtnText, flexSpendUsed, flexSpendRemain) {

          var form = flexSpendAdd.closest('form'),
              maxUse = localStorage.getItem("flexMaxUse"),
              flexCharge = localStorage.getItem("flexCharge");
              
          maxUse = parseFloat(maxUse);
          flexCharge = parseFloat(flexCharge);

          // remove flex item from sessionStorage
          if (sessionStorage.getItem('flexproduct-' + productID) != null) {
            sessionStorage.removeItem('flexproduct-' + productID);
          }

          // change the button text/style
          flexSpendAdd.classList.remove('added');
          flexSpendBtnText.textContent = "Pay With BDF";

          // disable the default button action
          // form.addEventListener('submit', function (event) {
          //   event.preventDefault();
          // });

          var line, QTY;
          cartDrawer = document.getElementById('cart-dropdown');
          cartDrawer.querySelectorAll('.flexSpendCartItem a.cart-item__remove').forEach(function(item){
            if (item.getAttribute('data-product-id') == productID) {
            line = parseFloat(item.getAttribute('data-line'));
            QTY = item.closest('.cart-item__content').querySelector('span[data-qty]').getAttribute('data-qty');
            QTY = parseFloat(QTY);
            }
          });
          
          async function cartJsRemoveFromCart(){
            //return CartJS.removeItemById(variantID)
            //return  CartJS.removeItem(line)
            return CartJS.updateItem(line, 0)
          }
          
          cartJsRemoveFromCart().then(function(){
            let _cartDrawer = window.cart;           
            setTimeout(function(){
              _cartDrawer.getCart();
              //_cartDrawer.openCartDropdown();
            },750);         

          }).then(function(){
            updateCartDrawer();

          });


          // imitate the minicart 'removeItem' action
          //cart.querySelector('[data-product-id="' + productID + '"]').click();

          flexSpendItemPrice = flexSpendItemPrice * QTY;
          // flexspend: calculate
          flexSpendRemain = flexSpendRemain + flexSpendItemPrice;
          flexSpendUsed = flexSpendUsed - flexSpendItemPrice;


          // update sessionStorage "used" field
          localStorage.setItem("FlexSpendUsed", flexSpendUsed);

          // update flex spend remain/used/flexcharge info


          if (flexSpendRemain < 0) {

            
            flexCharge = flexCharge + flexSpendItemPrice;

            localStorage.setItem("flexCharge", flexCharge);

            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(0).toFixed(2);


            // show html info block if flexcharge < 0
            let html = flexSpendInfo.querySelector('span');
            flexCharge = Math.abs(flexCharge);
            
            html.innerHTML = "$" + flexCharge.toFixed(2);
            flexSpendInfo.classList.add('visible');

          } else {

            localStorage.removeItem("flexCharge");

            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(flexSpendRemain).toFixed(2);


            // hide html info block if flexcharge > 0
            flexSpendInfo.classList.remove('visible');
          }


          if (flexSpendUsed > maxUse) {

            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(maxUse).toFixed(2);

          } else {

            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(flexSpendUsed).toFixed(2);
          }

          if (flexSpendUsed < 0) {

            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(0).toFixed(2);

          }
         
        }

        function addFlexSpend(flexSpendAdd, productID, variantID, flexSpendItemPrice, itemPriceNonDecimal, flexSpendBtnText, flexSpendUsed, flexSpendRemain) {

          var maxUse = localStorage.getItem("flexMaxUse"),
              _flexSpendDiscountAmount,
              QTY = flexSpendAdd.closest('.product-item').querySelector('input.quantity__input').getAttribute('value');

              QTY = parseFloat(QTY);
                   
              maxUse = parseFloat(maxUse);

           // change button text/style when item was added   
          
           flexSpendBtnText.textContent = "";
           flexSpendAdd.querySelector('.svg-loader').classList.add('loader-active');

          setTimeout(function(){
            flexSpendAdd.querySelector('.svg-loader').classList.remove('loader-active');
            flexSpendBtnText.textContent = "Remove From BDF";
            flexSpendAdd.classList.add('added');
          },2500);

          // document.dispatchEvent(
          //   new CustomEvent('cart:add')
          // );

          flexSpendItemPrice = flexSpendItemPrice * QTY;
          itemPriceNonDecimal = itemPriceNonDecimal * QTY;

          if (flexSpendRemain > flexSpendItemPrice) {
           _flexSpendDiscountAmount = itemPriceNonDecimal;
           }
   
           else if (flexSpendRemain < 0) {
            _flexSpendDiscountAmount = 0
           }

           else {
            _flexSpendDiscountAmount = flexSpendRemain * 100;
           }
   
           async function cartJsAddToCart(){
             return CartJS.addItem(variantID , QTY, {
               '_isFlexSpendProduct': true,
   
               '_flexSpendDiscountAmount':  _flexSpendDiscountAmount
   
             });
           }
   
           cartJsAddToCart().then(function(){
             let _cartDrawer = window.cart;     
             setTimeout(function(){
               _cartDrawer.getCart();
               // _cartDrawer.openCartDropdown();
             },1250); 
   
           }).then(function(){
             updateCartDrawer();
   
           });

           sessionStorage.setItem("sessionUsesBFD", true );

          // add flex item to sessionStorage
          if (sessionStorage.getItem('flexproduct-' + productID) == null) {
            sessionStorage.setItem('flexproduct-' + productID, flexSpendItemPrice);
          }

          // flexspend: calculate
          flexSpendRemain = flexSpendRemain - flexSpendItemPrice;
          flexSpendUsed = flexSpendUsed + flexSpendItemPrice;

          // update sessionStorage "used" field
          localStorage.setItem("FlexSpendUsed", flexSpendUsed);

     

          if (flexSpendRemain < 0) {
            // update flex spend remain/used info
            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(0).toFixed(2);

            localStorage.setItem("flexCharge", flexSpendRemain);

            // show html info block if flexcharge < 0
            let html = flexSpendInfo.querySelector('span');
            flexCharge = Math.abs(flexSpendRemain);
          
            html.innerHTML = "$" + flexCharge.toFixed(2);
            flexSpendInfo.classList.add('visible');

          } else {
            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(flexSpendRemain).toFixed(2);

            // hide html info block if flexcharge > 0
            flexSpendInfo.classList.remove('visible');
          }

          if (flexSpendUsed > maxUse) {
            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(maxUse).toFixed(2);

          } else {

            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(flexSpendUsed).toFixed(2);

          }   

         
        }
      });

    }

    // function used for removing the flex item from minicart

    function removeItemFlexFromCart(item) {

      item.addEventListener('click', function () {

        document.getElementById("flexspend-overlay").classList.add('show-flex-overlay');
         setTimeout(function(){
        document.getElementById("flexspend-overlay").classList.remove('show-flex-overlay');
        },3500);

        if (item.closest('.cart-item').classList.contains('flexSpendCartItem')) {
  
        
      var data = item.getAttribute('data-product-id'),
          flexSpendItemPrice = sessionStorage.getItem('flexproduct-' + data),
          maxUse = localStorage.getItem("flexMaxUse"),
          variantID = item.getAttribute('data-variant-id');
          
          maxUse = parseFloat(maxUse);

          //console.log(flexSpendItemPrice);

        //   setTimeout(function(){
        //     CartJS.updateItemById(variantID,0)        
        //  },500);
        
        if (flexPage) {
          var btn = document.getElementById('flexspend__addbtn-' + data);
        }

        flexSpendItemPrice = parseFloat(flexSpendItemPrice);

        sessionStorage.removeItem('flexproduct-' + data);

        if (flexPage && btn) {
          let btnText = btn.querySelector('span');
          flexSpendRemain = Number(flexSpendRemainSelector.getAttribute('data-remaining'));
          btn.classList.remove('added');
          btnText.textContent = "Pay With Flex Spend";
          flexSpendRemain = flexSpendRemain + flexSpendItemPrice;
        }
          flexSpendUsed = localStorage.getItem("FlexSpendUsed");
          flexSpendUsed = parseFloat(flexSpendUsed);

          
        flexSpendUsed = flexSpendUsed - flexSpendItemPrice;
          
        var flexCharge = localStorage.getItem("flexCharge");
        flexCharge = parseFloat(flexCharge);

        if (flexSpendUsed > maxUse) {

          flexCharge = flexCharge + flexSpendItemPrice;
          localStorage.setItem("flexCharge", flexCharge);

          if (flexPage) {
            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(0).toFixed(2);

            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(maxUse).toFixed(2);

            let html = flexSpendInfo.querySelector('span');
            flexCharge = Math.abs(flexSpendRemain);
            
            html.innerHTML = "$" + flexCharge.toFixed(2);
            flexSpendInfo.classList.add('visible');

          }
        } else {

          localStorage.removeItem("flexCharge", flexCharge);

          if (flexPage) {

            flexSpendRemainSelector.setAttribute("data-remaining", flexSpendRemain);
            flexSpendRemainSelector.textContent = Number(flexSpendRemain).toFixed(2);

            flexSpendUsedSelector.setAttribute("data-used", flexSpendUsed);
            flexSpendUsedSelector.textContent = Number(flexSpendUsed).toFixed(2);

            flexSpendInfo.classList.remove('visible');
          }

        }

        localStorage.setItem("FlexSpendUsed", flexSpendUsed);

        updateCartDrawer();
        updateCart();
      
      }

      else {
        setTimeout(function(){
          CartJS.updateItemById(variantID,0)        
       },2500);

       updateCartDrawer();
       updateCart();

      }
 
      });
    }



    function updateCartDrawer(){

      setTimeout(function () {
        var cart = document.getElementById('cart-dropdown');

        if (cart) {

         var cartLineRemove = cart.querySelectorAll('.cart-item__remove');
          //console.log(cartLineRemove);
          cartLineRemove.forEach(function (item) {  
            //console.log(item); 
             //indicateFlexProduct(item);
             removeItemFlexFromCart(item);
        });
      }
      }, 3500);

    }

    function updateCart(){

      setTimeout(function () {
        var cart = document.querySelector('.cart__form');

        if (cart) {
          cartLineRemove = cart.querySelectorAll('.cart-item__remove');

          cartLineRemove.forEach(function (item) {   
             //indicateFlexProduct(item);
             removeItemFlexFromCart(item);
        });
      }
      }, 3500);

    }

    // indicate the flex item in minicart and add specific class (old script)
    function indicateFlexProduct(item) {
     
      var data = item.getAttribute('data-product-id');

      if (sessionStorage.getItem('flexproduct-' + data)) {
        item.closest('.cart-item').classList.add('flexSpendCartItem');
        item.closest('.cart-item').querySelector('.cart-item__title a').addEventListener('click', function(e){
          e.preventDefault();
        });
      }
    }


    //**********************************
    // END Flex Spend Functionality Scripts 
    //**********************************

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();




$( document ).ready(function() {

    //**********************************
    // FlexSpend scripts. Check subtotal when adding/removing regular (nonFlexSpend) products 
    // Hides "Checkout" and Dynamic Checkout buttons if changed "subtotal price" < than allowed flexspend amount.
    // Otherwise, shows checkout buttons again 
    //**********************************


//setTimeout(checkSubtotal, 1500);
checkSubtotal();
cartPageOverlayOnReload();

  function checkSubtotal() {

 
    var flexBtns = $(document).find('[id^="flexspend__addbtn-"]'),
        quantity = $(document).find("#cart-dropdown [data-quantity-button], .template-cart [data-quantity-button]"),     
        input =  $(document).find(".cart__quantity input"),
        line_item_remove = $(document).find("[data-item-remove]"),
        flexPage = $(document).find('#flexspend__wrapper'),
        cartPage = $(document).find('.cart__form'),
        cartDrawer = $(document).find('#cart-dropdown'),
        cart = jQuery.getJSON('/cart.js');

 
    //   flexBtns.each(function(){
       
    //   $(this).on('click',function(e){

    //     setTimeout(function(){
         
    //       checkSubtotal();

    //     },2500);    

    //   });
    // });

      line_item_remove.each(function(){
       
        $(this).on('click',function(e){

          cartPageOverlayOnReload();

          setTimeout(function(){
            
            checkSubtotal();

          },2500);
          

        });
      });

      quantity.each(function(e){    

        $(this).on('click',function(){
          cartPageOverlayOnReload();

          setTimeout(function(){
            
            checkSubtotal();

          },3000);
          
        });
      });

      input.each(function(e){    

        $(this).on('input',function(){
          cartPageOverlayOnReload();

          setTimeout(function(){
            
            checkSubtotal();

          },3000);
          
        });
      });

        if (flexPage.length != 0) {
        
        flexData = $.parseJSON($('#flexSendData').html());

        $.each(flexData, function(key, value){
          
          if (key == 'tiers') {
             
            localStorage.setItem(key, JSON.stringify(value));
            
          }
        });
      }

  
      var tiers = localStorage.getItem('tiers'),
          tiers = JSON.parse(tiers);

      cart.done(function(){
          cart = cart.responseJSON;

          var subtotal = cart.items_subtotal_price,
              cartItems = cart.items;

              //console.log(subtotal);

              if (tiers) { 

              for (var i in tiers) {
                
                if (subtotal >= tiers[i].min && subtotal <= tiers[i].max ) {
                  
                   var changedDiscountAmount = (subtotal / 100) * tiers[i].funds,
                   totalDiscountAmount = Number(0);

               $.each(cartItems, function(keyAmount, valueAmount){
                 
               var itemDiscountAmount = parseFloat(valueAmount.properties._flexSpendDiscountAmount);
               
               if (itemDiscountAmount) {
                  totalDiscountAmount = totalDiscountAmount + itemDiscountAmount
               }
               
               });

                //console.log("changedDiscountAmount= " + changedDiscountAmount);
                //console.log("currentDiscountAmount= " + totalDiscountAmount);
             
               if (changedDiscountAmount < totalDiscountAmount) {
                
                  if (cartPage.length != null){
                    
                    cartPage.find('.cart__checkout.flex-actioned').hide().attr('disabled', 'disabled');
                    cartPage.find('.additional-checkout-buttons').hide();
                    cartPage.find('.cart__or').hide();
                    if (cartPage.find('.flex-alert').length == 0) {
                    cartPage.find('.cart__foot-inner').append("<p class='flex-alert'>Your subtotal has changed.  You must remove some BDF products from your cart before checking out.</p>");
                  }
                  }
           
                  if (cartDrawer.length !=null){
                   cartDrawer.find('.btn').hide();
                   cartDrawer.find('.flex-spend-skip').hide();
                   cartDrawer.find('.additional-checkout-buttons').hide();
                   if (cartDrawer.find('.flex-alert').length == 0) {
                     cartDrawer.find('form ').append("<p class='flex-alert'>Your subtotal has changed.  You must remove some BDF products from your cart before checking out.</p>");
                 }
                 }
               }
           
               else {
           
                 if (cartPage.length !=null){
                  
                   cartPage.find('.cart__checkout.flex-actioned').show().removeAttr('disabled');
                   cartPage.find('.additional-checkout-buttons').show();
                   cartPage.find('.cart__or').show();
                   if (cartPage.find('.flex-alert').length != 0) {
                     cartPage.find('.flex-alert').remove();
                 }
                 }
           
                 if (cartDrawer.length !=null){
                   cartDrawer.find('.btn').show();
                   cartDrawer.find('.flex-spend-skip').show();
                   cartDrawer.find('.additional-checkout-buttons').show();
                   if (cartDrawer.find('.flex-alert').length != 0) {
                     cartDrawer.find('form').find('.flex-alert').remove();
                 }
                 }          
           
               }

                   break; //Stop loop if found
                }

                if ( cartPage.find('.cart-item:not(.flexSpendCartItem)').length == 0 || cartDrawer.find('.cart-item:not(.flexSpendCartItem)').length == 0  ) {

                  if (cartPage.length !=null){
                    cartPage.find('.cart__checkout.flex-actioned').hide();
                    cartPage.find('.additional-checkout-buttons').hide();
                    cartPage.find('.cart__or').hide();
                    if (cartPage.find('.flex-alert').length == 0) {
                    cartPage.find('.cart__foot-inner').append("<p class='flex-alert'>Your subtotal has changed.  You must remove some BDF products from your cart before checking out.</p>");
                  }
                  }
           
                  if (cartDrawer.length !=null){
                   cartDrawer.find('.btn').hide();
                   cartDrawer.find('.flex-spend-skip').hide();
                   cartDrawer.find('.additional-checkout-buttons').hide();
                   if (cartDrawer.find('.flex-alert').length == 0) {
                     cartDrawer.find('form ').append("<p class='flex-alert'>Your subtotal has changed.  You must remove some BDF products from your cart before checking out.</p>");
                 }
                 }
                }

                if ( cartPage.find('.cart-item').length == 0 && cartDrawer.find('.cart-item').length == 0 ) {
                  if (cartPage.length !=null){
                    
                    cartPage.find('.cart__checkout.flex-actioned').show();
                    cartPage.find('.additional-checkout-buttons').show();
                    if (cartPage.find('.flex-alert').length != 0) {
                      cartPage.find('.flex-alert').remove();
                  }
                  }
            
                  if (cartDrawer.length !=null){
                   
                    cartDrawer.find('.btn').show();
                    cartDrawer.find('.flex-spend-skip').show();
                    cartPage.find('.additional-checkout-buttons').show();
                    if (cartDrawer.find('.flex-alert').length != 0) {
                      cartDrawer.find('form').find('.flex-alert').remove();
                  }
                  } 
                }
           
//                 else if (subtotal <= tiers[i].min) {

//                 console.log("< 50")
//                      if (cartPage.length !=null){
//                        cartPage.find('.cart__checkout').hide();
//                        if (cartPage.find('.flex-alert').length == 0) {
//                        cartPage.find('.cart__foot-inner').append("<p class='flex-alert'>You haven't met the minimum order value to start using Flex Spend</p>");
                     
//                      }
//                      }
              
//                      if (cartDrawer.length !=null){
//                       cartDrawer.find('.btn').hide();
//                       cartDrawer.find('.flex-spend-skip').hide();
//                       if (cartDrawer.find('.flex-alert').length == 0) {
//                         cartDrawer.find('form ').append("<p class='flex-alert'>You haven't met the minimum order value to start using Flex Spend</p>");
//                     }
//                     }            

//                   break;
//                 }
              }
            }
           
        });
   }

    //**********************************
    // FlexSpend scripts. Check subtotal END
    //**********************************

function cartPageOverlayOnReload () {

  cartPage = $(document).find('.cart__form');

  if ( cartPage.find('.cart-item').length != 0) {

    $(document).find("#flexspend-overlay").addClass('show-flex-overlay');
    setTimeout(function(){
      $(document).find("#flexspend-overlay").removeClass('show-flex-overlay');
    },3000);
  }
  
}


    //**********************************
    // Collection pages. Placing banner description after below the banner on screen sizes < 750px
    //**********************************


  var isCollection = $(".template-collection");

  if (isCollection.length > 0) {
    const headerSection = $("[data-section-id*=hero]"),
          description = headerSection.find(".hero__description");

    if (description) {
      if($(window).width() < 750) {
        headerSection.append(description);
        headerSection.find(".hero__content__wrapper").find(description).remove();      
     }
     $(window).resize(function(){
       if($(window).width() < 750) {   
        if (headerSection.find('.collection__image').next(description).length == 0) {
          headerSection.append(description);
        }
        headerSection.find(".hero__content__wrapper").find(description).remove();
       }
       else {   
        headerSection.find('.hero__content').append(description);
        headerSection.find('.collection__image').next(description).remove();    
       }    
    }); 
    }    
  } 

  
    //**********************************
    // Quick Order page. Updating  minicart counter and cartdrawer items when adding items using quick order "add to cart" buttons
    //**********************************

  var isQuickOrder = $("#wof_order_from_main_container");

  if (isQuickOrder.length > 0) {

    var text = isQuickOrder.find('#lbl_cart_total');
    text.on('DOMSubtreeModified',function(){
           let _cartDrawer = window.cart;     
          setTimeout(function(){
            _cartDrawer.getCart();  
            checkSubtotal();      
          },500); 
       });  
  }


$(document).find('.bdf-quantity-selector').each(function(){

var input = $(this).find('.quantity__input'),
    plus = $(this).find('.quantity__plus'),
    minus = $(this).find('.quantity__minus'),
    minValue =  parseInt(input.attr('min')),
    maxValue =  parseInt(input.attr('max'));

    plus.on('click', function () {
      var inputValue = input.val();
      if (inputValue < maxValue) {
        input.val(parseInt(inputValue) + 1);
        input.attr('value', parseInt(inputValue) + 1);
        input.parents('.select__fieldset').next().find('a').attr('data-quantity', parseInt(inputValue) + 1);
      }
      });
      
      minus.on('click', function () {
        var inputValue = input.val();
        if (inputValue < maxValue && inputValue > minValue) {
          input.val(parseInt(inputValue) - 1);
          input.attr('value', parseInt(inputValue) - 1);
          input.parents('.select__fieldset').next().find('a').attr('data-quantity', parseInt(inputValue) - 1);
        }
      });

      input.on('change keydown', function(){

        setTimeout(function(){
          var inputValue = input.val();
          input.attr('value', parseInt(inputValue));
        },150);
        
      });

});

$("#bdf-fltr--btn").on('click', function(){

     if($(this).attr('aria-expanded') == 'false') {
      $(this).attr('aria-expanded', 'true');
     }
     else {
      $(this).attr('aria-expanded', 'false');
     }
  
  $(this).next("#coll-fltr").toggleClass('popout-list--visible');
});

$("#coll-fltr li button").each(function(){
$(this).on('click', function(){
  $(this).closest(".select-popout").attr('data-selected', $(this).find('span').text() );
  var title = $(this).attr('data-title');
  //ga('send', 'event', 'BDF Filter', 'Click', title);
  $('#bdf-fltr--btn').text(title);
  gtag("event", "Click", {
    "event_category": "BDF Filter",
    "event_label": title,
    "value": title
});
});
});

$(document).on('click', function(e){
  if(!$(e.target).closest("#coll-fltr").length && !$(e.target).closest("#bdf-fltr--btn").length ){
   $("#bdf-fltr--btn").attr('aria-expanded', 'true');
   $("#coll-fltr").removeClass('popout-list--visible');
  }
}); 

    //**********************************
    // Change position of Attrac announcement banner
    //**********************************


    // const bannerPos = setInterval(changePos, 1000);

    // function changePos(){
    //   let banner = $(document).find('[id^="bar"]'),
    //       headerCont =  $(document).find('[data-header-wrapper]'),
    //       headerContMob = headerCont.find('.drawer__content'),
    //       header = headerCont.find(' header');
    //         if (banner.length > 0) {   
    //           banner.insertBefore(header).addClass('replaced');
    //           headerCont.css('top', 'auto');
    //           headerContMob.css('top', 'auto');
    //           clearInterval(bannerPos);
    //         }
    //         else {
    //           headerCont.removeAttr('style');
    //           headerContMob.removeAttr('style');   
    //         }
    // }


});


